import React from "react";
import { FormGroup } from "@cofano/cck";
import { Language } from "imports/Utils";
import { headerMap } from "view/products/utils/ProductUtils";
import { CargoTankDesign, productCargoTankDesignField } from "view/products/components/form/fields/ProductCargoTankDesign";
import { CargoTankType, productCargoTankTypeField } from "view/products/components/form/fields/ProductCargoTankType";
import { productCargoTankEquipmentField } from "view/products/components/form/fields/ProductCargoTankEquipment";
import { productSamplingTypeField, SamplingType } from "view/products/components/form/fields/ProductSamplingType";
import { productTankerTypeField } from "view/products/components/form/fields/ProductTankerType";
import { productTemperatureClassField } from "view/products/components/form/fields/ProductTemperatureClass";
import { productEquipmentField } from "view/products/components/form/fields/ProductEquipment";
import { AdnGoodFragment } from "__generated__/view/products/graphql/product.fragments.generated";

export const ProductAdnDetails = ({ adnGood }: { adnGood: AdnGoodFragment }) => {
	return (
		<React.Fragment>
			<FormGroup label={Language("PRODUCT_ADN_ADN_CODE")} overflow="hidden">
				{adnGood?.adnCode || "-"}
			</FormGroup>

			<FormGroup label={headerMap["unNumber"]} overflow="hidden">
				{adnGood?.unNumber || "-"}
			</FormGroup>

			<FormGroup label={headerMap["properShippingNameEN"]} overflow="hidden">
				{adnGood?.properShippingNameEN || "-"}
			</FormGroup>

			<FormGroup label={headerMap["properShippingNameNL"]} overflow="hidden">
				{adnGood?.properShippingNameNL || "-"}
			</FormGroup>

			<FormGroup label={headerMap["properShippingNameDE"]} overflow="hidden">
				{adnGood?.properShippingNameDE || "-"}
			</FormGroup>

			<FormGroup label={headerMap["properShippingNameFR"]} overflow="hidden">
				{adnGood?.properShippingNameFR || "-"}
			</FormGroup>

			<FormGroup label={headerMap["classNumber"]} overflow="hidden">
				{adnGood?.classNumber || "-"}
			</FormGroup>

			<FormGroup label={headerMap["classificationCode"]} overflow="hidden">
				{adnGood?.classificationCode || "-"}
			</FormGroup>

			<FormGroup label={headerMap["packingGroup"]} overflow="hidden">
				{adnGood?.packingGroup || "-"}
			</FormGroup>

			<FormGroup label={headerMap["hazards"]} overflow="hidden">
				{adnGood?.hazards || "-"}
			</FormGroup>

			<FormGroup label={headerMap["tankerType"]} overflow="hidden">
				{productTankerTypeField(adnGood?.tankerType)}
			</FormGroup>

			<FormGroup label={headerMap["cargoTankDesign"]} overflow="hidden">
				{productCargoTankDesignField(adnGood?.cargoTankDesign as keyof typeof CargoTankDesign | undefined)}
			</FormGroup>

			<FormGroup label={headerMap["cargoTankType"]} overflow="hidden">
				{productCargoTankTypeField(adnGood?.cargoTankType as keyof typeof CargoTankType | undefined)}
			</FormGroup>

			<FormGroup label={headerMap["cargoTankEquipment"]} overflow="hidden">
				{productCargoTankEquipmentField(adnGood?.cargoTankEquipment)}
			</FormGroup>

			<FormGroup label={headerMap["openingPressureRelieveValve"]} overflow="hidden">
				{adnGood?.openingPressureRelieveValve || "-"}
			</FormGroup>

			<FormGroup label={headerMap["maxFillingDegreePercentage"]} overflow="hidden">
				{adnGood?.maxFillingDegreePercentage || "-"}
			</FormGroup>

			<FormGroup label={headerMap["density"]} overflow="hidden">
				{adnGood?.density || "-"}
			</FormGroup>

			<FormGroup label={headerMap["densityTemperature"]} overflow="hidden">
				{adnGood?.densityTemperature || "-"}
			</FormGroup>

			<FormGroup label={headerMap["samplingType"]} overflow="hidden">
				{productSamplingTypeField(adnGood?.samplingType as keyof typeof SamplingType | undefined)}
			</FormGroup>

			<FormGroup label={headerMap["permissiblePumpChamberUnderDeck"]} overflow="hidden">
				{adnGood?.permissiblePumpChamberUnderDeck != null ? (adnGood.permissiblePumpChamberUnderDeck ? Language("YES") : Language("NO")) : "-"}
			</FormGroup>

			<FormGroup label={headerMap["temperatureClass"]} overflow="hidden">
				{productTemperatureClassField(adnGood?.temperatureClass)}
			</FormGroup>

			<FormGroup label={headerMap["explosionGroup"]} overflow="hidden">
				{adnGood?.explosionGroup || "-"}
			</FormGroup>

			<FormGroup label={headerMap["explosionProtectionRequired"]} overflow="hidden">
				{adnGood?.explosionProtectionRequired != null ? (adnGood.explosionProtectionRequired ? Language("YES") : Language("NO")) : "-"}
			</FormGroup>

			<FormGroup label={headerMap["requiredEquipment"]} overflow="hidden">
				{productEquipmentField(adnGood?.requiredEquipment)}
			</FormGroup>

			<FormGroup label={headerMap["numberOfBlueConesOrLights"]} overflow="hidden">
				{adnGood?.numberOfBlueConesOrLights || "-"}
			</FormGroup>

			<FormGroup label={headerMap["extraRequirements"]} overflow="hidden">
				{adnGood?.extraRequirements || "-"}
			</FormGroup>
		</React.Fragment>
	);
};

export default ProductAdnDetails;
